import React from 'react';
import PropTypes from 'prop-types';

import css from './TransactionStatus.module.css';
import classNames from 'classnames';

import {
  txIsCanceled,
  txIsEnquired,
  txIsPurchased,
  txIsDelivered,
  txIsDisputed,
  txIsPaymentExpired,
  txIsPaymentPending,
  txIsReceived,
  txIsCompleted,
  txIsReviewedByCustomer,
  txIsReviewedByProvider,
  txIsReviewed,
} from '../../util/transaction';

//translated fullfilment status
export const txFullfillmentState = (intl, tx, type) => {
  if (txIsEnquired(tx)) {
    return {
      lastTransitionedAtClassName: css.lastTransitionedAtEmphasized,
      stateClassName: css.stateActionNeeded,
    };
  } else if (txIsPaymentPending(tx)) {
    return {
      stateClassName: css.paymentPending,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.statePendingPayment',
      }),
    };
  } else if (txIsPaymentExpired(tx)) {
    return {
      stateClassName: css.cancelled,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.statePaymentExpired',
      }),
    };
  } else if (txIsCanceled(tx)) {
    return {
      stateClassName: css.cancelled,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.stateCanceled',
      }),
    };
  } else if (txIsPurchased(tx)) {
    return {
      stateClassName: css.inTransport,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.statePurchased',
      }),
    };
  } else if (txIsDelivered(tx)) {
    return {
      stateClassName: css.inTransport,
      state: intl.formatMessage({ id: 'InboxPageBuyer.stateDeliveredCustomer' }),
    };
  } else if (txIsDisputed(tx)) {
    return {
      stateClassName: css.stateActionNeeded,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.stateDisputed',
      }),
    };
  } else if (txIsReceived(tx) || txIsCompleted(tx)) {
    return {
      stateClassName: css.review,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.stateReceived',
      }),
    };
  } else if (txIsReviewedByCustomer(tx)) {
    const translationKey = 'InboxPageBuyer.stateReviewGiven';
    return {
      stateClassName: css.review,
      state: intl.formatMessage({
        id: translationKey,
      }),
    };
  } else if (txIsReviewedByProvider(tx)) {
    const translationKey = 'InboxPageBuyer.stateReviewNeeded';
    return {
      stateClassName: css.review,
      state: intl.formatMessage({
        id: translationKey,
      }),
    };
  } else if (txIsReviewed(tx)) {
    return {
      stateClassName: css.completed,
      state: intl.formatMessage({
        id: 'InboxPageBuyer.stateReviewed',
      }),
    };
  } else {
    console.warn('This transition is unknown:', tx.attributes.lastTransition);
    return null;
  }
};

export const TransactionStatus = props => {
  const { tx, intl } = props;
  const stateData = txFullfillmentState(intl, tx);

  return (
    <div className={classNames(stateData.stateClassName, css.fullfillmentRow)}>
      <div className={css.dot}> </div>
      {stateData.state}
    </div>
  );
};

const { object } = PropTypes;

TransactionStatus.defaultProps = {
  tx: null,
  intl: null,
};

TransactionStatus.propTypes = {
  tx: object,
  intl: object,
};

export default TransactionStatus;
